import React, { FC } from 'react';
import { Badge, BadgeType } from '@components/atoms/Badge';
import { useTranslation } from 'react-i18next';

interface WorkerStateBadgeProps {
    state: string;
}

export const WorkerStateBadge: FC<WorkerStateBadgeProps> = ({ state }) => {
    const { t } = useTranslation();

    const translations = {
        activeLabel: t('worker-state.active'),
        inactiveLabel: t('worker-state.inactive'),
    };

    switch (state) {
        case 'active':
            return <Badge label={translations.activeLabel} type={BadgeType.success} icon="fa-light fa-check" />;
        case 'inactive':
            return <Badge label={translations.inactiveLabel} type={BadgeType.danger} icon="fa-light fa-xmark" />;
        default:
            <></>;
    }
};
